<template>
	<div class="mb-3" style="display: inline-block">
		<egranty-input-field-popup
			:is-open.sync="isAdding"
			title="Dodaj możliwość liczby modułów"
			label="liczba modułów (np. 2)"
			for="contest-possible-modules-count-number-modules"
			id="contest-possible-modules-count-number-modules"
			:required="false"
			:disabled="disabled"
			@save="addOption"
		></egranty-input-field-popup>

		<div class="ml-3 mb-2">Dopuszczalne liczby modułów:</div>

		<div v-if="!possibleCounts.length" class="mt-4">
			<em>Brak możliwości</em>
		</div>

		<div>
			<v-layout>
				<div v-for="(key,index) in possibleCounts" v-bind:key="index">
					<v-chip
						:disabled="disabled"
						close
						@input="remove(index)"
					>
						<strong>{{ key.count }}</strong>&nbsp;
					</v-chip>
				</div>
			</v-layout>
		</div>

		<div class="mt-3 mb-3">
			<v-btn
				:disabled="disabled"
				@click="isAdding=true">
				Dodaj
			</v-btn>

			<v-btn
				:disabled="disabled"
				@click="clear" v-if="possibleCounts.length">
				Wyczyść możliwości
			</v-btn>
		</div>

		<div v-if="error!==''" style="color:rgb(255, 23, 68);">
			{{error}}
		</div>
	</div>
</template>

<script>
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "ContestPossibleModulesCount",
		components: {EgrantyInputFieldPopup},
		methods: {
			addOption(value) {
				this.isAdding = false;
				var parsed = parseFloat(value);
				if (isNaN(parsed)) {
					return;
				}
				let newPossibility = {
					id: null,
					count: parsed,
				};
				for (let existing in this.possibleCounts) {
					if (this.possibleCounts[existing].count === newPossibility.count) {
						return;
					}
				}
				this.possibleCounts.push(newPossibility);
				this.error = "";
				this.$emit("input", this.possibleCounts);
			},

			clear() {
				this.possibleCounts = [];
				this.$emit("input", this.possibleCounts);
			},

			remove(index) {
				this.possibleCounts.splice(index, 1);
				this.$emit("input", this.possibleCounts);
			},

			validate() {
				if (!this.possibleCounts.length) {
					this.error = "Proszę podać co najmniej jedną dopuszczalną liczbę modułów";
					return false;
				}
				return true;
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.possibleCounts = val;
				},
			},
		},

		data() {
			return {
				isAdding: false,
				possibleCounts: [],
				error: "",
			};
		},
		props: {
			value: {},
			disabled: {type: Boolean, default: false},
		},
	};
</script>

<style scoped>

</style>
